import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "passengersImg",
  src: "/assets/images/Framepeople-icon.png",
  alt: "user-image"
}
const _hoisted_2 = {
  key: 1,
  class: "passengersImg",
  src: "/assets/images/userActive.svg",
  alt: "user-image"
}
const _hoisted_3 = { class: "passengersContent" }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "modal-mask" }
const _hoisted_6 = { class: "modal-wrapper" }
const _hoisted_7 = { class: "modal-content" }
const _hoisted_8 = {
  class: "modal-header",
  id: "passengersModalHeader"
}
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "passengersModalText" }
const _hoisted_11 = { class: "passengersModalButtons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "passengersComponent",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleModal(true)))
    }, [
      (!_ctx.passengersModal)
        ? (_openBlock(), _createElementBlock("img", _hoisted_1))
        : _createCommentVNode("", true),
      (_ctx.passengersModal)
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.$t('passengers')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.passengerCount), 1)
      ]),
      (_ctx.passengersModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_Transition, { name: "passengersModal" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "close",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.closeModal(false)), ["stop"]))
                        }, _cache[5] || (_cache[5] = [
                          _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
                        ]))
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('passengers')), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t('choose_passenger_count')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("img", {
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.decreasePassengerCount && _ctx.decreasePassengerCount(...args))),
                            src: "/assets/images/minus-circle.svg",
                            alt: "user-image"
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.passengerCount) + " ", 1),
                          _createElementVNode("img", {
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.increasePassengerCount && _ctx.increasePassengerCount(...args))),
                            src: "/assets/images/plus-circle.svg",
                            alt: "user-image"
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.passengersModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "closePassengersModal",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeModal(false)))
        }))
      : _createCommentVNode("", true)
  ], 64))
}